"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dynosRevisions = dynosRevisions;

var _I18n = _interopRequireDefault(require("I18n"));

var _underscore = require("underscore");

var _ActionTypes = require("lead-flows-ui/constants/ActionTypes");

var INITIAL_STATE = {
  isFetching: false,
  fetchingHasError: false,
  revisions: {}
};

function dynosRevisions() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _ActionTypes.REQUEST_DYNO_REVISIONS:
      return Object.assign({}, state, {
        isFetching: true
      });

    case _ActionTypes.RECEIVE_DYNO_REVISIONS:
      {
        var revisions = (0, _underscore.chain)(action.payload.results).map(function (item) {
          var date = _I18n.default.moment(item.auditCreatedAt).format('YYYY-MM-DD');

          return {
            date: date,
            revisions: item.changes || []
          };
        }).groupBy('date').mapObject(function (days) {
          return (0, _underscore.chain)(days).map(function (day) {
            return day.revisions;
          }).flatten().uniq().value();
        }).value();
        return Object.assign({}, state, {
          isFetching: false,
          revisions: Object.assign({}, state.revisions, revisions)
        });
      }

    case _ActionTypes.ERROR_DYNO_REVISIONS:
      return Object.assign({}, state, {
        isFetching: false,
        fetchingHasError: true,
        fetchingRecentError: action.payload
      });

    default:
      return state;
  }
}